import React from 'react';
import { ReactComponent as DocIcon } from 'assets/icons/icon-document.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/icon-trash.svg';
import OrgReportUploader from './OrgReportUploader';
import { useHasura } from 'context/ApiState';

const OrgReports = ({ organisation }) => {
  return (
    <div className="card">
      <div className="cardBody">
        <aside>
          <h2 className="mb-4 text-lg text-gray-800">Reports</h2>
          <h3 className="mb-4 text-base font-semibold text-gray-600">
            Upload a new Report
          </h3>
          <OrgReportUploader orgId={organisation?.id} className="mt-5" />
        </aside>
        <main>
          <div className="w-full mt-4 wrapper-fixed-height">
            {organisation?.organisation_reports?.length < 1 ? (
              <div className="flex items-center justify-center h-full text-gray-400 select-none">
                No Reports
              </div>
            ) : (
              organisation?.organisation_reports?.map(
                ({ id, report_date, report_title, upload }) => (
                  <Report
                    key={id}
                    id={upload.id}
                    date={report_date}
                    title={report_title}
                  />
                ),
              )
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

const Report = ({ id, date, title }) => {
  const { removeOrgReport } = useHasura();
  return (
    <div className="flex items-center w-full p-3 mb-3 rounded-lg cursor-pointer bg-jcap-100">
      <DocIcon className="inline w-10 h-12 mr-2 pointer-events-none text-jcap-400" />
      <div className="flex flex-col flex-grow pointer-events-none select-none">
        <p className="text-sm font-semibold">
          {date}
          {title && ' - ' + title}
        </p>
        <p className="text-xs text-gray-600">
          PDF <span className="text-gray-400">{id?.split('-')[0]}</span>
        </p>
      </div>
      <TrashIcon
        className="inline w-6 h-6 mr-1 text-red-400 hover:text-red-600"
        onClick={() => removeOrgReport(id)}
      />
    </div>
  );
};

export default OrgReports;
